import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Login.css';
import { setDocumentTitle } from '../../utils/DocumentTitle';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Set document title and body class when component mounts
  useEffect(() => {
    setDocumentTitle('Login');
    // Add login-page class to body for full gray background
    document.body.classList.add('login-page');
    // Cleanup function to remove the class when component unmounts
    return () => {
      document.body.classList.remove('login-page');
    };
  }, []);

  const { email, password } = formData;

  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Use axios default baseURL (set in index.js)
      const res = await axios.post('/api/auth/login', formData);

      // Save token to localStorage
      localStorage.setItem('token', res.data.token);

      // Save the full user object returned by the API to localStorage
      // This object should include permissions and onboarding status
      if (res.data.user) {
        localStorage.setItem('user', JSON.stringify(res.data.user));
        console.log('Stored user object from API response in localStorage:', res.data.user);
      } else {
        // Fallback or error handling if user object is missing
        console.error('User object missing in login response.');
        setError('Login failed: Incomplete user data received.');
        setLoading(false);
        return; // Prevent redirect if user data is missing
      }

      // Redirect to dashboard (PrivateRoute will handle onboarding check)
      navigate('/');
    } catch (err) {
      setError(
        err.response && err.response.data.message
          ? err.response.data.message
          : 'Login failed. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h1 className="login-title">Leadbooster CRM</h1>
      <h2 className="login-subtitle">Sign in to your account</h2>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}
      
      <form onSubmit={onSubmit}>
        <div>
          <label htmlFor="email" style={{display: 'none'}}>
            Email address
          </label>
          <input
            id="email"
            name="email"
            type="email"
            required
            value={email}
            onChange={onChange}
            className="login-input"
            placeholder="Email address"
          />
        </div>
        <div>
          <label htmlFor="password" style={{display: 'none'}}>
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            required
            value={password}
            onChange={onChange}
            className="login-input"
            placeholder="Password"
          />
        </div>

        <div>
          <button
            type="submit"
            disabled={loading}
            className="login-button"
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </div>
        
        {/* Registration functionality disabled */}
      </form>
      <p className="mt-4 text-sm text-center text-gray-600">
        <Link to="/forgot-password" className="font-medium text-indigo-600 hover:text-indigo-500">
          Forgot your password?
        </Link>
      </p>
    </div>
  );
};

export default Login;
